/**
 * The location a guarded route needs the login page to come back to. Only the
 * router's own serialization is read: `href` already carries the path, the
 * search string and the hash, encoded.
 */
interface RedirectableLocation {
  href: string;
}

/**
 * Build the `?redirect=` search a guarded route throws at `/login`.
 *
 * The trap this exists to close: a router location's `search` is the PARSED
 * search OBJECT, not a query string, so `location.pathname + location.search`
 * stringifies to `/home[object Object]`. The customer then signs in
 * successfully and lands on the router's Not Found page, with no way out but
 * hand-editing the URL.
 *
 * `validateRedirect` is the other end of this contract: it decides what the
 * login page will accept back.
 */
export function loginRedirectSearch(location: RedirectableLocation): { redirect: string } {
  return { redirect: location.href };
}
